import '../../styles/fonts.css';
import React from 'react';
import { Chat } from '../../types/chat';
import { formatTime } from '../../utils/formatters';
import { EmojiRenderer } from '../common/EmojiRenderer';

interface ChatItemProps {
  chat: Chat;
  isSelected: boolean;
  onClick: () => void;
}

export const ChatItem: React.FC<ChatItemProps> = ({ chat, isSelected, onClick }) => {
  const isSystemChat = chat.id === 0;

  return (
    <div
      onClick={onClick}
      style={{
        backgroundColor: isSelected ? '#8181810E' : '#fff',
        padding: '12px',
        paddingLeft: '24px',
        cursor: 'pointer',
        position: 'relative',
        borderBottom: '1px solid #eee',
      }}
      onMouseEnter={(e) => {
        if (!isSelected) {
          e.currentTarget.style.backgroundColor = '#8181810E';
        }
      }}
      onMouseLeave={(e) => {
        if (!isSelected) {
          e.currentTarget.style.backgroundColor = '#fff';
        }
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '8px',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                fontFamily: 'monospace',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              {isSystemChat ? 'Тёрка' : chat.companionNumber}
            </div>

            {chat.lastMessage?.time && (
              <div
                style={{
                  fontFamily: 'monospace',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#0000004D',
                }}
              >
                [{chat.lastMessage.time}]
              </div>
            )}

            {chat.isNew && !chat.lastMessage && (
              <div
                style={{
                  fontFamily: 'monospace',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  color: '#000000CC',
                  border: '1px solid #000000',
                  padding: '2px 6px',
                }}
              >
                Новый
              </div>
            )}
          </div>

          <div
            style={{
              fontFamily: 'monospace',
              fontSize: '12px',
              marginTop: '4px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            <EmojiRenderer
              text={chat.lastMessage?.preview || (isSystemChat ? 'Общий чат' : 'Нет сообщений')}
              emojiSize={18}
            />
          </div>
        </div>

        <div style={{ textAlign: 'right' }}>
          {chat.unreadCount > 0 && !chat.isGroupChat && (
            <div
              style={{
                backgroundColor: '#000',
                color: '#fff',
                fontSize: '12px',
                width: '20px',
                height: '20px',
                borderRadius: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '4px',
                marginLeft: 'auto',
              }}
            >
              {chat.unreadCount}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
